<template>
  <el-dropdown trigger="click">
    <div class="flex items-center gap-2 cursor-pointer">
      <img
        :src="avatar"
        class="w-8 h-8 border-2 border-gray-200 rounded-full"
      />
      <span :class="nameClass">{{ displayName }}</span>
      <el-icon :size="12"><ArrowDown /></el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item @click="handleLogout">
          <el-icon><SwitchButton /></el-icon>
          退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { ArrowDown, SwitchButton } from '@element-plus/icons-vue';
import { useUserStore } from '@/store/modules/user';

const props = withDefaults(defineProps<{
  nameClass?: string;
  logoutRedirect?: string;
}>(), {
  nameClass: 'text-sm font-medium text-gray-700',
  logoutRedirect: '/',
});

const router = useRouter();
const userStore = useUserStore();

const avatar = computed(() => {
  if (userStore.userInfo?.avatar) {
    return userStore.userInfo.avatar;
  }
  // 根据性别使用本地 SVG，1=男，2=女
  const gender = userStore.userInfo?.gender;
  if (gender === 2) {
    return '/svg/woman.svg';
  }
  return '/svg/man.svg';
});
const displayName = computed(() => userStore.userInfo?.realName || userStore.userInfo?.username || '');

const handleLogout = () => {
  userStore.logout();
  router.push(props.logoutRedirect);
};
</script>
